import { createFileRoute } from '@tanstack/react-router';

import { PaymentsPage } from '@/areas/settings/manufacturing/Settings/PaymentsPage/PaymentsPage';
import { canViewCustomerPortalSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/settings/_menu/organization/customer-portal/payment-credentials',
)({
    staticData: {
        access: { permissions: canViewCustomerPortalSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PaymentsPage />;
}
